import React from "react";
import { motion } from "framer-motion";
import { useContent } from "../../hooks/useContent";

const defaultStats = [
    { label: "Years Active", value: "08" },
    { label: "Projects Shipped", value: "150+" },
    { label: "Global Clients", value: "40+" }
];

const defaultClients = [
    "Google", "Spotify", "Nike", "Adidas", "Tesla", "SpaceX", "Linear", "Vercel"
];

const About = () => {
  const { content } = useContent("about");
  const { content: trustedContent } = useContent("trusted_by");

  const headline_1 = content?.headline_1 || "WE ARE";
  const headline_2 = content?.headline_2 || "DIGITAL ALCHEMISTS";
  const description = content?.description || "Xluma is more than an agency. We are a collective of visionaries, engineers, and artists dedicated to redefining the digital landscape. We don't just build websites; we create digital ecosystems that breathe.";
  const stats = content?.stats || defaultStats;
  
  // Trusted By section
  const trustedTitle = trustedContent?.title || "Trusted by Industry Leaders";
  const clients = trustedContent?.clients?.length > 0 ? trustedContent.clients : defaultClients;
  const trustedEnabled = trustedContent?.enabled !== false;

  return (
    <section className="py-20 md:py-32 px-4 md:px-12 bg-black text-white border-b border-white/10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 lg:gap-32 mb-20 md:mb-32">
            <div>
                <h2 className="text-4xl sm:text-5xl md:text-7xl font-display font-bold leading-[0.9] mb-6 md:mb-8">
                    {headline_1} <br/> <span className="text-accent">{headline_2}</span>
                </h2>
            </div>
            <div className="flex flex-col justify-between">
                <p className="text-lg md:text-xl lg:text-2xl text-gray-400 font-light leading-relaxed mb-10 md:mb-12">
                    {description}
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
                    {stats.map((stat, i) => (
                        <div key={i}>
                            <h3 className="text-3xl md:text-4xl lg:text-5xl font-mono font-bold text-white mb-2">{stat.value}</h3>
                            <p className="text-[10px] md:text-xs uppercase tracking-widest text-gray-500">{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>

        {/* Client Marquee */}
        {trustedEnabled && (
        <div className="border-t border-b border-white/10 py-8 md:py-12 overflow-hidden">
            <h3 className="text-center text-[10px] md:text-xs uppercase tracking-widest text-gray-600 mb-6 md:mb-8">{trustedTitle}</h3>
            <div className="flex whitespace-nowrap">
                 <motion.div 
                    className="flex gap-12 md:gap-20"
                    animate={{ x: "-50%" }}
                    transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
                >
                    {[...clients, ...clients, ...clients, ...clients].map((client, i) => (
                        <span key={i} className="text-2xl md:text-3xl lg:text-5xl font-display font-bold text-gray-800 hover:text-white transition-colors duration-300 uppercase">
                            {client}
                        </span>
                    ))}
                </motion.div>
            </div>
        </div>
        )}
      </div>
    </section>
  );
};

export default About;
